var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1678_28730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7222 0H2.5202C1.40448 0 0.5 0.89543 0.5 2V14C0.5 15.1046 1.40448 16 2.5202 16H22.7222C23.8379 16 24.7424 15.1046 24.7424 14V2C24.7424 0.89543 23.8379 0 22.7222 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59152 13C12.3808 13 14.642 10.7614 14.642 8C14.642 5.23858 12.3808 3 9.59152 3C6.8022 3 4.54102 5.23858 4.54102 8C4.54102 10.7614 6.8022 13 9.59152 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 13C18.4414 13 20.7026 10.7614 20.7026 8C20.7026 5.23858 18.4414 3 15.6521 3C12.8628 3 10.6016 5.23858 10.6016 8C10.6016 10.7614 12.8628 13 15.6521 13Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6218 3.99951C13.8485 4.91172 14.642 6.36406 14.642 7.99988C14.642 9.6357 13.8485 11.088 12.6218 12.0002C11.3951 11.088 10.6016 9.6357 10.6016 7.99988C10.6016 6.36406 11.3951 4.91172 12.6218 3.99951Z",
    fill: "#FF5F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_28730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2424,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/Paypal.2a9126e0c99d0035088d4f530c1b1c4c.svg";
export { ForwardRef as ReactComponent };